// getHeader function to add token to request headers.
export const getHeader = () => {
  return {
    "Content-Type": "application/json",
  }
}

// postHeader function to add token to request headers.
export const postHeader = (format: any) => {
  return {
    'Content-Type': (format || 'audio/webm'),
    'Accept': (format || 'audio/webm')
  }
}

export const uploadAudioFileDetails = (
  blob: Blob,
  format: any,
  fileName: string,
  testTakerDetails: any,
  insperaDetails: any,
  timestamps?: {
    recordingStartTimestamp?: string;
    recordingEndTimestamp?: string;
  }
) => {  // Create a FormData object
  const formData = new FormData();
  formData.append('file', blob, testTakerDetails?.testTakerId + "_" + fileName + format);
  formData.append('testTakerId', testTakerDetails?.testTakerId);
  formData.append('cmsSessionId', testTakerDetails?.testTakerSessionId);
  formData.append('productType',insperaDetails.product === 'CRELLA' ? 'GT' : insperaDetails.product);
  formData.append('partnerId',insperaDetails?.partner);
  formData.append('assessmentId',insperaDetails?.assessmentId);
  formData.append('externalId',insperaDetails?.externalId);
  if (timestamps?.recordingStartTimestamp) {
    formData.append("recordingStartTimestamp", timestamps.recordingStartTimestamp);
  }

  if (timestamps?.recordingEndTimestamp) {
    formData.append("recordingEndTimestamp", timestamps.recordingEndTimestamp);
  }
  return formData;
};

